/* Spintronik Wellen. Ordnung, die sich stoeren laesst und zurueckfindet.
   Auf Ruhe im Betrieb getrimmt: halbe Bildrate, weniger Punkte, kein Ebenenfilter. */
(function () {
  function starte(wurzel) {
    var c = wurzel.querySelector('canvas.welle');
    if (!c || wurzel.dataset.wellegestartet === 'ja') return;
    if (wurzel.dataset.welle === 'false') { c.style.display = 'none'; return; }

    var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var klein = window.matchMedia('(max-width: 750px)').matches;
    if (klein && wurzel.dataset.wellemobil === 'false') { c.style.display = 'none'; return; }

    wurzel.dataset.wellegestartet = 'ja';

    var ctx = c.getContext('2d', { alpha: true, desynchronized: true });
    var farbe = wurzel.dataset.akzentrgb || '31,95,208';
    var deck = parseFloat(wurzel.dataset.welledeckkraft || '1');
    var LINIEN = parseInt(wurzel.dataset.wellelinien || '7', 10);
    var von = parseFloat(wurzel.dataset.wellevon || '0.26');
    var bis = parseFloat(wurzel.dataset.wellebis || '0.76');

    if (klein) LINIEN = Math.max(3, Math.round(LINIEN / 2));
    var PROLINIE = klein ? 70 : 110;
    var FEDER = 0.055, DAEMPF = 0.90, REICHW = 150, KRAFT = 26;
    var BILDABSTAND = 1000 / 30;

    var B = 0, H = 0, punkte = [], rx = [], ry = [], verlauf = [];
    var maus = { x: -9999, y: -9999, aktiv: false };
    var t0 = null, letzte = 0, laeuft = true, angefordert = false;

    c.style.opacity = deck;

    function aufbau() {
      var r = c.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      B = Math.round(r.width); H = Math.round(r.height);
      c.width = Math.round(B * dpr); c.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      punkte = []; rx = []; ry = []; verlauf = [];
      for (var l = 0; l < LINIEN; l++) {
        var reihe = new Array(PROLINIE);
        for (var i = 0; i < PROLINIE; i++) reihe[i] = { dx: 0, dy: 0, vx: 0, vy: 0 };
        punkte.push(reihe);
        rx.push(new Float32Array(PROLINIE));
        ry.push(new Float32Array(PROLINIE));

        var rand = Math.abs(l - (LINIEN - 1) / 2) / Math.max((LINIEN - 1) / 2, 1);
        var a = 0.34 - rand * 0.20;
        var g = ctx.createLinearGradient(0, 0, B, 0);
        g.addColorStop(0, 'rgba(' + farbe + ',' + a.toFixed(3) + ')');
        g.addColorStop(Math.min(von, 0.98), 'rgba(' + farbe + ',' + a.toFixed(3) + ')');
        g.addColorStop(Math.min(bis, 0.99), 'rgba(' + farbe + ',0)');
        g.addColorStop(1, 'rgba(' + farbe + ',0)');
        verlauf.push(g);
      }
    }

    function ruhelage(zeit) {
      var mitte = H * 0.60;
      for (var l = 0; l < LINIEN; l++) {
        var amp = 30 + l * 4;
        var versatz = (l - (LINIEN - 1) / 2) * 26;
        var p1 = zeit * 0.28 + l * 0.30;
        var p2 = -zeit * 0.19 + l * 0.55;
        for (var i = 0; i < PROLINIE; i++) {
          var u = i / (PROLINIE - 1);
          rx[l][i] = -0.05 * B + u * B * 1.10;
          ry[l][i] = mitte + versatz
            + Math.sin(u * Math.PI * 3.0 + p1) * amp
            + Math.sin(u * Math.PI * 6.4 + p2) * amp * 0.36;
        }
      }
    }

    function schritt() {
      for (var l = 0; l < LINIEN; l++) {
        var reihe = punkte[l], gx = rx[l], gy = ry[l];
        for (var i = 0; i < PROLINIE; i++) {
          var p = reihe[i];
          if (maus.aktiv) {
            var ax = (gx[i] + p.dx) - maus.x;
            var ay = (gy[i] + p.dy) - maus.y;
            var d2 = ax * ax + ay * ay;
            if (d2 < REICHW * REICHW) {
              var d = Math.sqrt(d2) || 1;
              var f = 1 - d / REICHW;
              p.vx += (ax / d) * f * KRAFT * 0.16;
              p.vy += (ay / d) * f * KRAFT * 0.16;
            }
          }
          p.vx = (p.vx - FEDER * p.dx) * DAEMPF;
          p.vy = (p.vy - FEDER * p.dy) * DAEMPF;
          p.dx += p.vx; p.dy += p.vy;
        }
      }
    }

    function zeichne() {
      ctx.clearRect(0, 0, B, H);
      ctx.lineWidth = 1.15;
      for (var l = 0; l < LINIEN; l++) {
        var reihe = punkte[l], gx = rx[l], gy = ry[l];
        ctx.beginPath();
        for (var i = 0; i < PROLINIE; i++) {
          var x = gx[i] + reihe[i].dx, y = gy[i] + reihe[i].dy;
          if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
        }
        ctx.strokeStyle = verlauf[l];
        ctx.stroke();
      }
      var m = Math.floor((LINIEN - 1) / 2);
      var grenze = B * bis;
      ctx.fillStyle = 'rgba(' + farbe + ',.40)';
      ctx.beginPath();
      for (var k = 0; k < PROLINIE; k += 5) {
        var px = rx[m][k] + punkte[m][k].dx;
        if (px > grenze) break;
        var py = ry[m][k] + punkte[m][k].dy;
        ctx.moveTo(px + 1.5, py);
        ctx.arc(px, py, 1.5, 0, Math.PI * 2);
      }
      ctx.fill();
    }

    function lauf(ms) {
      angefordert = false;
      if (!laeuft) return;
      if (t0 === null) { t0 = ms; letzte = ms - BILDABSTAND; }
      if (ms - letzte >= BILDABSTAND) {
        letzte = ms;
        var zeit = (ms - t0) / 1000;
        ruhelage(zeit);
        schritt();
        zeichne();
      }
      anfordern();
    }

    function anfordern() {
      if (angefordert || !laeuft) return;
      angefordert = true;
      requestAnimationFrame(lauf);
    }

    aufbau();
    if (reduziert) { ruhelage(0); zeichne(); }
    else { anfordern(); }

    wurzel.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      var r = c.getBoundingClientRect();
      maus.x = e.clientX - r.left; maus.y = e.clientY - r.top; maus.aktiv = true;
    }, { passive: true });
    wurzel.addEventListener('pointerleave', function () { maus.aktiv = false; }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) {
            if (!laeuft && !reduziert) { laeuft = true; t0 = null; anfordern(); }
          } else { laeuft = false; }
        });
      }, { threshold: 0.02 }).observe(wurzel);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { laeuft = false; }
      else if (!reduziert) { laeuft = true; t0 = null; anfordern(); }
    });

    var timer;
    function spaeter() { clearTimeout(timer); timer = setTimeout(function () { aufbau(); if (reduziert) { ruhelage(0); zeichne(); } }, 150); }
    if ('ResizeObserver' in window) { new ResizeObserver(spaeter).observe(c); }
    else { window.addEventListener('resize', spaeter); }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(spaeter); }
  }

  function alle() { document.querySelectorAll('.spintronik-dach').forEach(starte); }
  document.addEventListener('DOMContentLoaded', alle);
  alle();
  document.addEventListener('shopify:section:load', function (e) {
    var w = e.target.querySelector('.spintronik-dach');
    if (w) { w.dataset.wellegestartet = ''; starte(w); }
  });
})();
